const DAY = 86400000;

export const accountListFindings = (rows = [], { actions = {}, now = Date.now() } = {}) => {
  const list = Array.isArray(rows) ? rows : [];
  const out = [];
  const noOwner = list.filter(r => !r.owner && !r.ownerId);
  if (noOwner.length) {
    out.push({
      tone: "warn",
      key: "no_owner",
      label: `${noOwner.length} account${noOwner.length === 1 ? "" : "s"} without an owner`,
      text: "Unowned accounts get no follow-up. Assign them.",
      actions: actions.assignOwner ? [{ label: "Assign owner", run: () => actions.assignOwner(noOwner) }] : []
    });
  }
  const idle = list.filter(r => r.lastContactedTs && now - r.lastContactedTs > 60 * DAY).length;
  if (idle) {
    out.push({
      tone: "warn",
      key: "idle_accounts",
      label: `${idle} account${idle === 1 ? "" : "s"} idle for 60+ days`,
      text: "Nobody has touched them in two months. Re-engage or close.",
      actions: actions.reengage ? [{ label: "Re-engage", run: actions.reengage }] : []
    });
  }
  return out;
};

export const accountDetailFindings = ({ contactsTotal = 0, unsequenced = 0, openTasks = 0, actions = {} } = {}) => {
  const out = [];
  if (contactsTotal === 0) {
    out.push({ tone: "warn", key: "no_contacts", label: "No contacts in this account", text: "Find people at this company to work it.", actions: actions.findPeople ? [{ label: "Find people", run: actions.findPeople }] : [] });
  } else if (unsequenced > 0) {
    out.push({ tone: "hot", key: "unsequenced", label: `${unsequenced} contacts not in a sequence`, text: "They are saved but nobody is reaching out.", actions: actions.addToSequence ? [{ label: "Add to sequence", run: actions.addToSequence }] : [] });
  } else if (contactsTotal === 1) {
    out.push({ tone: "neutral", key: "single_contact", label: "Only one contact here", text: "Single-threaded deals stall. Find two more personas at this company.", actions: actions.findPeople ? [{ label: "Find people", run: actions.findPeople }] : [] });
  }
  if (openTasks > 0) {
    out.push({ tone: "neutral", key: "open_tasks", label: `${openTasks} open tasks`, text: "Knock these out from the Tasks tab.", actions: actions.showTasks ? [{ label: "Show tasks", run: actions.showTasks }] : [] });
  }
  return out;
};
